import '../css/screen.css'

import './core/polyfill'
import init from './init'

document.addEventListener('DOMContentLoaded', init, false)
